import { apiUrl } from '../api';

const ERROR_MESSAGES: Record<string, string> = {
  not_authorized: 'That Apple ID is not authorized to access this app.',
  user_cancelled_authorize: 'Sign-in was cancelled.',
  token_exchange_failed: 'Apple sign-in failed (token exchange). Please try again.',
  invalid_id_token: 'Apple sign-in failed (invalid identity token). Please try again.',
  bad_state: 'Sign-in session expired. Please try again.',
};

function detailMessage(detail: string): string {
  if (detail === 'private_relay') {
    return 'You signed in with "Hide My Email", so Apple sent a private relay address. Go to Settings → your name → Sign-In & Security → Sign in with Apple → Unburdened Messages → Stop Using Apple ID, then sign in here again and choose "Share My Email".';
  }
  if (detail.startsWith('email:')) {
    return `Apple sent the email "${detail.slice(6)}", which is not the owner's address for this app.`;
  }
  if (detail === 'no_email') {
    return 'Apple did not include an email with the sign-in. Remove this app under Settings → your name → Sign-In & Security → Sign in with Apple, then try again and choose "Share My Email".';
  }
  return detail;
}

export function LoginScreen({ error, detail }: { error: string | null; detail: string | null }) {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-sm rounded-xl bg-white p-8 shadow-md text-center">
        <div className="text-4xl mb-3">🔒</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-1">Unburden Messages</h1>
        <p className="text-sm text-gray-600 mb-6">This is a private archive. Sign in to continue.</p>

        {error && (
          <div className="mb-4 rounded bg-red-50 px-3 py-2 text-sm text-red-700 text-left">
            <p>{ERROR_MESSAGES[error] || `Sign-in failed: ${error}`}</p>
            {detail && <p className="mt-2">{detailMessage(detail)}</p>}
          </div>
        )}

        <a
          href={apiUrl('/auth/apple/login')}
          className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-black px-4 py-3 text-white hover:bg-gray-800"
        >
          <svg viewBox="0 0 814 1000" className="h-5 w-5 fill-current" aria-hidden="true">
            <path d="M788 341c-6 4-107 61-107 187 0 146 128 197 132 199-1 3-20 70-67 138-42 60-86 120-152 120s-83-38-159-38c-74 0-101 39-161 39s-102-55-150-123C68 783 24 660 24 543c0-187 122-286 242-286 64 0 117 42 157 42 38 0 97-45 170-45 27 0 127 3 195 87zM554 168c30-36 52-86 52-136 0-7-1-14-2-19-49 2-108 33-143 74-28 31-54 81-54 132 0 8 2 15 2 18 3 0 8 1 13 1 44 0 100-30 132-70z" />
          </svg>
          Sign in with Apple
        </a>

        <p className="mt-4 text-xs text-gray-400">Only the owner's Apple ID is accepted.</p>
      </div>
    </div>
  );
}
